import moment from 'moment';

export const date6monthsBefore = moment()
  .subtract(6, 'M')
  .format('YYYY-MM-DDThh:mm:ss');

export const date12monthsBefore = moment()
  .subtract(12, 'M')
  .format('YYYY-MM-DDThh:mm:ss');

export const date1weekBefore = moment()
  .subtract(1, 'w')
  .format('YYYY-MM-DDThh:mm:ss');
